<template>
  <v-container class="app-page-container">
      <v-card class="shadow-none app-page-card">
            <v-layout wrap>
              <div v-if="getShowModalMessageResult">{{processModalResult()}}</div>
              <div v-if="need_init && getLanguageIcons && user">{{initData()}}</div>
              
              <v-flex xs12 v-if="prepared">
                <v-card class="shadow-none">
                  <v-card-text>
                    <v-layout>
                      <v-flex xs11>
                        <h2>{{content.brc.lesson.name}}</h2>
                      </v-flex>
                      <v-flex xs1>
                        <small>primary language:</small> <br/>
                        <v-menu class="lang-wrapper" offset-y>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on" class="lang-change-widget background-transparent shadow-none">
                              <img class="lang-icon" :src="getLanguageIcons[lang_index].url"/> {{ getLanguageIcons[lang_index].title }}
                            </v-btn>
                          </template>
                            <v-list dense>
                              <v-list-item-group>
                                <v-list-item v-for="(language, index) in getLanguageIcons" :key="index" @click="langClick(index)">
                                  <img class="lang-icon" :src="language.url"/>
                                  <v-list-item-title v-text="language.title"></v-list-item-title>
                                </v-list-item>
                              </v-list-item-group>
                            </v-list>
                        </v-menu>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                  <v-card-text v-if="access_denied">
                      <v-layout align-center>
                        <h1>You don't have a permission to edit this content.</h1>
                      </v-layout>
                  </v-card-text>

                      <v-card v-if="!access_denied" class="shadow-none">
                        <div v-for="(element, index) in content.element_list" :key="element.id" class="universal-row-item">                                
                          <v-layout class="px-5">                
                            <v-flex xs10> 
                                <TaskElement v-bind:my_element='element' v-bind:permissions = 'content.permissions.list' v-bind:lang_index='""+lang_index' v-bind:brc = 'content.brc' v-bind:item_index='index+1'/>
                            </v-flex>
                            <v-flex xs2 class="vertically-horizontally-centered">
                              <v-layout v-if="getObjectPermissions()"> 


                                <v-icon @click="cloneTask(index)">mdi-layers</v-icon>
                                <v-icon @click="tryDeleteElement(index)" class="mx-2">mdi-delete</v-icon>
                                <div class="arrow-ordering-items mx-2">
                                  <v-icon @click="index > 0 ? changeOrder(index-1) : ''" :class="['material-icons-round', (index == 0) ? 'arrow-ordering-items__icon--disabled cursor-not-allowed':'']">arrow_upward</v-icon>
                                  <v-icon @click="index < content.element_list.length-1 ? changeOrder(index) : ''" :class="['material-icons-round', (index == content.element_list.length-1) ? 'arrow-ordering-items__icon--disabled cursor-not-allowed':'']">arrow_downward</v-icon>
                                </div>                                
                                
                                <v-checkbox hide-details class="shrink ml-4 mt-1" v-model="selected" :value="element.id"></v-checkbox>
                                
                              </v-layout>
                            </v-flex>
                          </v-layout>                             
                        </div> 
                        <v-card color = "#DDDDFF" v-if="getObjectPermissions()">
                          <v-card-text>
                            <v-layout row wrap>
                              <v-flex xs5>{{selected}}</v-flex>
                              <v-flex xs2>
                                <v-card outlined>
                                  <v-card-text>
                                <v-layout row justify-center>                
                                  <v-menu class="lang-wrapper" top>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-icon v-bind="attrs" v-on="on" class="lang-change-widget background-transparent shadow-none">
                                        mdi-plus-circle-outline
                                      </v-icon>
                                    </template>
                                      <v-list dense>
                                        <v-list-item-group>
                                          <v-list-item v-for="(icon, index) in task_icons" :key="index" @click="newTasks(index+1)">
                                            <v-icon style="margin-right:3px">{{icon.icon}}</v-icon>
                                            <v-list-item-title v-text="icon.descr"></v-list-item-title>
                                          </v-list-item>
                                        </v-list-item-group>
                                      </v-list>
                                  </v-menu>                              
                                </v-layout>    
                                  </v-card-text>
                                </v-card>    
                              </v-flex>
                               <v-flex xs5>
                                <v-card outlined color = "#DDDDFF">
                                  <v-card-text>
                                  <v-layout row justify-center align-center>
                                    <v-flex xs5>
                                      <v-menu transition="slide-y-transition" bottom right>
                                        <template v-slot:activator="{ on }">
                                            <v-btn class="my-3" v-on="on" style="width:100%" small>
                                              {{chapterText}}
                                              </v-btn>
                                        </template>
                                        <v-list>
                                          <v-list-item v-for="(item, i) in chapters" :key="i"  
                                            @click="changeChapter(i)" >
                                            <v-list-item-title>{{ item.name }}</v-list-item-title>
                                          </v-list-item>
                                        </v-list>
                                      </v-menu>                                      
                                    </v-flex>
                                    <v-flex xs5 v-if="chapters[selectedChapter]">
                                        <v-menu transition="slide-y-transition" bottom right >
                                          <template v-slot:activator="{ on }">
                                              <v-btn class="my-3" v-on="on" style="width:100%" small>
                                                {{lessonText}}
                                                </v-btn>
                                          </template>
                                          <v-list>
                                            <v-list-item v-for="(item, i) in chapters[selectedChapter].lessons" :key="i"  @click="selectedLesson = i; lessonText = chapters[selectedChapter].lessons[selectedLesson].lesson.substring(0,20)+'...'" >
                                              <v-list-item-title>{{ item.lesson }}</v-list-item-title>
                                            </v-list-item>
                                          </v-list>
                                        </v-menu>
                                      </v-flex>
                                      <v-flex xs2>
                                        <v-btn dense small class="btn-primary" style="margin-left:12px" @click="tryProcessSelected(4)">move</v-btn>
                                      </v-flex>
                                      <v-flex xs10></v-flex>
                                      <v-flex xs2>
                                          <v-btn dense small class="btn-primary" @click="tryProcessSelected(6)">delete</v-btn>
                                      </v-flex>
                                  </v-layout>
                                  </v-card-text>
                                </v-card>
                              </v-flex> 
                            </v-layout>
                          </v-card-text>
                        </v-card> 
                      </v-card>                  
                </v-card> 
              </v-flex>
          </v-layout>
      </v-card>
  </v-container>
</template>

<script>
import axios from '../../../axios-auth.js'
import TaskElement from './task_element.vue'
import {mapGetters} from 'vuex'
import * as icn from '../../../assets/task_icons.js'

  export default {
    data() {
      return {
        content: [],
        access_denied: false,
        lang_index: 0,
        need_init : false,
        prepared : false,
        systemPermissions: null,
        deleteIndex : -1,
        task_icons: [],
        selected: [],
        chapters: [],
        selectedChapter: -1,
        selectedLesson: -1,
        chapterText: '',
        lessonText: '',
        currentChapterId: -1
      }
    },
    computed: 
        mapGetters([
                        'getShowModalMessageResult',
                        'getLanguageIcons',
                        'user'                        
                    ])
    ,
    mounted () {
      this.need_init = true
      this.prepared = false
   },
   components :{
     TaskElement
   },
   methods: {
    initData() {        
        this.need_init = false
        this.task_icons = icn.getIcons()
        this.lang_index = localStorage.getItem('CourseLangIndex') == null ? this.user.lang_id-1 : localStorage.getItem('CourseLangIndex')
        const _data = {
            lang_id : this.getLanguageIcons[this.lang_index].id
        }
        this.systemPermissions = this.$store.getters.getSystemPermissions
        axios.post('/get-task-preview-list/' + this.$route.params.id, _data, this.$store.getters.getAxiosConfig)
            .then(res => {
                this.content = res.data                
                const bc = [
                    { text: res.data.brc.category.name, href: '/areas/' + res.data.brc.category.id },//#
                    { text: res.data.brc.area.name, href: '/courses/' + res.data.brc.area.id }, //#             
                    { text: res.data.brc.course.name + ' (user)', href: '/course_content/' + res.data.brc.course.id }, //#
                    { text: res.data.brc.course.name + ' (edit)', href: '/edit_chapters/' + res.data.brc.course.id }, //#
                    { text: res.data.brc.chapter.name, href: '/edit_lessons/' + res.data.brc.chapter.id }, //#
                    { text: res.data.brc.lesson.name, href: '/task_list/' + res.data.brc.lesson.id }, //#
                ]
                this.$store.commit('setBreadCrumbs',bc)   
                this.currentChapterId = res.data.brc.chapter.id                
                if (res.data.message != 'OK') {
                  this.access_denied = true
                  this.prepared = true
                  return
                }               
                // console.log(res.data)
                axios.get('/course-preview/' + res.data.brc.course.id, this.$store.getters.getAxiosConfig)
                .then((res2) => {
                    this.chapters = res2.data.chapterlist
                    if (this.chapters.length > 0) this.changeChapter(0)
                })
                .catch(error => {
                    this.$store.commit('setFeedback', error)
                })


                this.prepared = true               
            })
            .catch(error => {
                this.$store.commit('setFeedback', error)
            })
    },
    langClick(_index)  {
      localStorage.setItem('CourseLangIndex', _index)
      this.lang_index = _index   
    },
    getObjectPermissions() {
      if (this.content.permissions.list[0].role_code >= this.$store.getters.getSystemPermissions.course_content_creator) return true      
      if (this.content.permissions.list[0].role_code == this.$store.getters.getSystemPermissions.chapter_content_creator) return true
      return false
    },
    changeOrder(_index) {
      const _data = {
        id1: this.content.element_list[_index].id,
        id2: this.content.element_list[_index+1].id,
        order1: this.content.element_list[_index].task_order,
        order2: this.content.element_list[_index+1].task_order,
      }
      // console.log(this.content.element_list)
      // console.log(_index + ': ' + _data.id1 +', ' + _data.order1 + ' -> ' + _data.id2 +', ' + _data.order2)

      axios.post('/change-task-order', _data, this.$store.getters.getAxiosConfig)
        .then(res => {
          if (res.data.message != 'OK') {
            this.$store.commit('setFeedback', res.data.message)
            return
          }               
          const _o1 = this.content.element_list[_index].task_order
          const _o2 = this.content.element_list[_index + 1].task_order
          const _data1 = this.content.element_list[_index]
          this.content.element_list.splice(_index,1)
          this.content.element_list.splice(_index+1, 0, _data1)         
          this.content.element_list[_index].task_order = _o1
          this.content.element_list[_index+1].task_order = _o2
        })
        .catch(error => {
            this.$store.commit('setFeedback', error)
        })
    },

    tryDeleteElement(_index) {
      this.deleteIndex = _index
      this.$store.commit('setShowModalMessage',
                  {content: 'Are you sure?<br/>You want to delete task?', type: 'warning', 
                  buttons:[], icons:[{text:'close', color:'red', value: 1},{text:'done', color:'green', value: 2} ]})
    },
    processModalResult() {
      const res = this.getShowModalMessageResult
      this.$store.commit('setShowModalMessageResult',null)
      if (res == 2) this.deleteElement()        
      if (res == 4) this.processSelected(4)        
      if (res == 6) this.processSelected(6)        
    },
    deleteElement() {
      const _data = {
        id: this.content.element_list[this.deleteIndex].id,       
      }
      axios.post('/delete-task', _data, this.$store.getters.getAxiosConfig)
        .then(res => {
          if (res.data.message != 'OK') {
            this.$store.commit('setFeedback', res.data.message)
            return
          }     
          this.content.element_list.splice(this.deleteIndex,1)
          this.deleteIndex = -1
        })
        .catch(error => {
            this.$store.commit('setFeedback', error)
        })
    },
    newTasks(_index) {
       this.$router.push({name:'task_edit', params: {course_id: this.content.brc.course.id, id_type: _index,
       show_lang: this.lang_index, edit_lang: this.lang_index, 
       lesson_id: this.content.brc.lesson.id, id: 0}})
    },
    changeChapter(_index) {
      this.selectedChapter = _index 
      this.chapterText = this.chapters[_index].name.substring(0,20)+'...'; 
      if (this.chapters[_index].lessons.length>0) {
        this.selectedLesson = 0
        this.lessonText = this.chapters[_index].lessons[0].lesson.substring(0,20)+'...'
      } else {
        this.selectedLesson = -1
        this.lessonText = '---'
      }
    },
    tryProcessSelected(_type) {      
      if (this.selected.length == 0) return
      const _operation = _type == 6 ? 'delete' : 'move'
      this.$store.commit('setShowModalMessage',
                  {content: 'Are you sure?<br/>You want to '+_operation+' ' +this.selected.length + ' tasks?', type: 'warning', 
                  buttons:[], icons:[{text:'close', color:'red', value: _type-1},{text:'done', color:'green', value: _type} ]})
    },
    processSelected(_type) {
      const _operation = _type == 6 ? 'delete' : 'move'
      const _changes = JSON.stringify(this.selected)
      if (this.selectedChapter < 0 || this.selectedLesson < 0) return

      var _newLesson = 0
      var _newChapter = 0
      if (_operation == "move") {
        _newLesson = this.chapters[this.selectedChapter].lessons[this.selectedLesson].lesson_id
        _newChapter = this.chapters[this.selectedChapter].chapter_id         
      } else {
        _newChapter = this.currentChapterId   // chapter for delete
      }

      const _data = {
        operation: _operation,
        newLesson : _newLesson,
        newChapter : _newChapter,
        changes : _changes
      }

      axios.post('/multiple-changes2', _data, this.$store.getters.getAxiosConfig )
        .then((res) => {
          if (res.data.message == 'OK') this.initData()
          else this.$store.commit('setFeedback', res.data.message)
        })
        .catch(error => {
          this.$store.commit('setFeedback', error)
      })
    },
    cloneTask(_index) {
      const data = {
        task_id: this.content.element_list[_index].id
      }

      axios.post('/task-clone', data, this.$store.getters.getAxiosConfig )
      .then((res) => {
        // set data to var
        if (res.data.message == 'OK') this.initData()
        else this.$store.commit('setFeedback', res.data.message)
      })
      .catch(error => {
        this.$store.commit('setFeedback', error)
      })
    },

   }
  }
</script>

<style>

</style>